export default __webpack_public_path__ + "static/media/news_image01.cc66914f.png";